/* RESPONSIBLE TEAM: team-data-foundations */
const APP_PACKAGE_TABS = {
  description: 'description',
  settings: 'settings',
  onboarding: 'onboarding',
  health: 'health',
  auditing: 'auditing',
};

export { APP_PACKAGE_TABS };
